import {useState, useEffect, useRef} from 'react'
import clsx from 'clsx'
import {ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {defaultProfileImage} from '../../../../app/modules/core'
import {useAuth} from '../../../../app/modules/auth'
import {Link} from 'react-router-dom'
import Swal from 'sweetalert2'
import {GoTypography} from 'react-icons/go'
import {MdOutlineTextIncrease, MdOutlineTextDecrease} from 'react-icons/md'
import {KTIcon} from '../../../helpers'
import {IoMdLogOut} from 'react-icons/io'

const itemClass = 'ms-1 ms-lg-3'

const Navbar = () => {
  const {currentUser, logout} = useAuth()
  const [showDisplayMenu, setShowDisplayMenu] = useState(false)

  const menuRef: any = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (showDisplayMenu && menuRef.current && !menuRef.current.contains(event.target)) {
        setShowDisplayMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showDisplayMenu])

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your session.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, logout',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-light-danger btn-sm',
        cancelButton: 'btn btn-light btn-sm',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        logout() // your logout function
      }
    })
  }

  const handleFontSizeChange = (type: string) => {
    const root = document.documentElement
    const currentSize = parseFloat(getComputedStyle(root).getPropertyValue('--font-size-desktop'))
    const minSize = 8
    const maxSize = 16
    let newSize = currentSize
    if (type === 'increase' && currentSize < maxSize) newSize += 1
    if (type === 'decrease' && currentSize > minSize) newSize -= 1 // avoid too small text

    // Apply new font size
    root.style.setProperty('--font-size-desktop', `${newSize}px`)
    root.style.setProperty('--font-size-tablet', `${newSize}px`)
    root.style.setProperty('--font-size-mobile', `${newSize}px`)

    // Optional: save preference
    localStorage.setItem('preferredFontSize', JSON.stringify(newSize))
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      <div
        ref={menuRef}
        className={clsx('app-navbar-item position-relative', itemClass, 'd-lg-none')}
      >
        <button
          onClick={() => setShowDisplayMenu(!showDisplayMenu)}
          className={clsx(
            'btn btn-icon btn-outline w-40px h-40px',
            showDisplayMenu
              ? 'btn-primary btn-active-primary'
              : 'btn-color-gray-700 btn-active-color-primary'
          )}
          title='Display Settings'
        >
          <GoTypography />
        </button>

        {showDisplayMenu && (
          <div
            className='card shadow-sm position-absolute top-100 end-0 mt-2 p-4 bg-white'
            style={{width: '200px', zIndex: 1050}}
          >
            <h6 className='text-gray-800 fw-bold mb-3'>Font Size</h6>

            <div className='d-flex align-items-center justify-content-between border rounded p-1 bg-light'>
              <button
                onClick={() => handleFontSizeChange('decrease')}
                className='btn btn-icon btn-sm btn-active-white w-100'
                title='Decrease'
              >
                <i className='las la-minus fs-4'></i>
              </button>

              <span className='text-muted fw-bold px-2'>Aa</span>

              <button
                onClick={() => handleFontSizeChange('increase')}
                className='btn btn-icon btn-sm btn-active-white w-100'
                title='Increase'
              >
                <i className='las la-plus fs-4'></i>
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={clsx('app-navbar-item', itemClass, 'd-none d-lg-flex')}>
        <div className='d-flex'>
          <button
            onClick={() => handleFontSizeChange('decrease')}
            className='btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px'
            title='Decrease Font Size'
            aria-label='Decrease Font Size'
          >
            {/* <span className='fs-4 fw-bold'>A−</span> */}
            <MdOutlineTextDecrease className='fs-1' />
          </button>

          <button
            onClick={() => handleFontSizeChange('increase')}
            className='btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px ms-1 ms-lg-3'
            title='Increase Font Size'
            aria-label='Increase Font Size'
          >
            {/* <span className='fs-4 fw-bold'>A+</span> */}
            <MdOutlineTextIncrease className='fs-1' />
          </button>
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass='btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px' />
      </div>

      <div className='d-flex align-items-center'>
        <Link
          to='/my-profile'
          className='btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px ms-1 ms-lg-3'
          data-kt-menu-attach='parent'
        >
          <KTIcon iconName='user' className='fs-1' />
        </Link>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <button
          onClick={handleLogout}
          className={clsx(
            'btn btn-icon',
            'btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px'
          )}
          title='Logout'
        >
          <IoMdLogOut className='fs-1 text-danger' />

          {/* <i className='las la-sign-out-alt fs-1 fw-bold text-danger'></i> */}
        </button>
      </div>
    </div>
  )
}

export {Navbar}
